export const clinicInfo = {
  name: "Dr. Thamarai's Dental Care",
  phone: "075022 97680",
  address: "11/5, Albertponnuswamy street, Bharat Mata Road, Gandhi Nagar, Tambaram, Chennai, Tamil Nadu - 600059",
  email: "info@drthamaraidental.com",
  rating: "4.9",
  experience: "10+",
  happySmiles: "5100+"
};

export const menuItems = [
  {
    title: "Home",
    path: "/"
  },
  {
    title: "Dental Checkup",
    submenu: [
      { title: "Dental Checkup", path: "/dental-checkup-chennai" },
      { title: "Teeth Cleaning", path: "/teeth-cleaning-tambaram" },
      { title: "Scaling and Polishing", path: "/scaling-and-polishing-east-tambaram" },
      { title: "Tooth Filling", path: "/tooth-filling-chennai" },
      { title: "Dental X-ray", path: "/dental-xray-tambaram" }
    ]
  },
  {
    title: "Aligners Studio",
    submenu: [
      { title: "Invisible Braces", path: "/invisible-braces-chennai" },
      { title: "Clear Aligners", path: "/clear-aligners-east-tambaram" },
      { title: "Invisible Braces Cost", path: "/invisible-braces-cost-chennai" },
      { title: "Aligners for Crooked Teeth", path: "/aligners-for-crooked-teeth-tambaram" },
      { title: "Aligners for Gaps", path: "/aligners-for-teeth-gaps-east-tambaram" }
    ]
  },
  {
    title: "Braces Treatment",
    submenu: [
      { title: "Braces Treatment", path: "/braces-treatment-chennai" },
      { title: "Metal Braces", path: "/metal-braces-tambaram" },
      { title: "Ceramic Braces", path: "/ceramic-braces-east-tambaram" },
      { title: "Braces Cost", path: "/braces-cost-chennai" },
      { title: "Orthodontic Treatment", path: "/orthodontic-treatment-tambaram" }
    ]
  },
  {
    title: "Dental Implants",
    submenu: [
      { title: "Dental Implants", path: "/dental-implants-chennai" },
      { title: "Single Tooth Implant", path: "/single-tooth-implant-tambaram" },
      { title: "Full Mouth Implants", path: "/full-mouth-dental-implants-chennai" },
      { title: "Teeth Replacement", path: "/teeth-replacement-east-tambaram" },
      { title: "Implant Dentist", path: "/implant-dentist-tambaram" }
    ]
  },
  {
    title: "Dental Surgery",
    submenu: [
      { title: "Root Canal Treatment", path: "/root-canal-treatment-chennai" },
      { title: "RCT Dentist", path: "/rct-dentist-tambaram" },
      { title: "Gum Treatment", path: "/gum-treatment-east-tambaram" },
      { title: "Gum Disease Treatment", path: "/gum-disease-treatment-chennai" },
      { title: "Bleeding Gums Treatment", path: "/bleeding-gums-treatment-tambaram" }
    ]
  }
];

export const homePageData = {
  floatingCards: [
    {
      title: "",
      subtitle: "",
      image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/87afwn4w_card%201.jpg"
    },
    {
      title: "",
      subtitle: "",
      image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/zdp8mvhh_card%202.png"
    }
  ],
  services: [
    { name: "Clear Aligners", icon: "Smile" },
    { name: "Dental Implants", icon: "Activity" },
    { name: "Root Canal", icon: "Shield" },
    { name: "Kids Dentistry", icon: "Heart" },
    { name: "Laser Care", icon: "Zap" }
  ]
};

export const servicesContent = {
  "dental-checkup-chennai": {
    title: "Dental Checkup in Chennai | Dr. Thamarai's Dental Care",
    h1: "Best Dental Checkup in Chennai – Chennai",
    h2: "Comprehensive Dental Examination & Preventive Care",
    floatingCards: [
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/87afwn4w_card%201.jpg" },
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/zdp8mvhh_card%202.png" }
    ],
    intro: "Regular dental checkups are essential for maintaining optimal oral health. At Dr. Thamarai's Dental Care in East Tambaram, Chennai, we provide comprehensive dental examinations using advanced diagnostic equipment to detect and prevent dental issues early.",
    benefits: [
      "Early detection of cavities and gum disease",
      "Professional teeth cleaning and plaque removal",
      "Oral cancer screening and prevention",
      "Digital X-rays with minimal radiation",
      "Personalized oral hygiene guidance"
    ],
    process: [
      "Complete oral examination by experienced dentists",
      "Digital X-rays and diagnostic imaging",
      "Professional teeth cleaning and scaling",
      "Treatment planning and recommendations",
      "Follow-up scheduling and care instructions"
    ],
    faqs: [
      { q: "How often should I get a dental checkup?", a: "We recommend a dental checkup every 6 months for optimal oral health." },
      { q: "Is dental checkup painful?", a: "No, dental checkups are painless. Our gentle approach ensures comfort throughout the examination." },
      { q: "What is included in a dental checkup?", a: "A complete oral examination, X-rays if needed, teeth cleaning, and personalized care recommendations." }
    ]
  },
  "teeth-cleaning-tambaram": {
    title: "Teeth Cleaning in Tambaram | Professional Dental Cleaning",
    h1: "Professional Teeth Cleaning in Tambaram – Chitlapakkam",
    h2: "Deep Cleaning for Healthy Teeth & Gums",
    floatingCards: [
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/87afwn4w_card%201.jpg" },
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/zdp8mvhh_card%202.png" }
    ],
    intro: "Professional teeth cleaning at Dr. Thamarai's Dental Care in Tambaram Sanatorium removes stubborn plaque, tartar, and stains that regular brushing cannot eliminate. Our advanced cleaning techniques ensure your teeth stay healthy and bright.",
    benefits: [
      "Removes hardened plaque and tartar buildup",
      "Prevents gum disease and tooth decay",
      "Fresher breath and cleaner mouth feel",
      "Brightens teeth by removing surface stains",
      "Reduces risk of cavities and infections"
    ],
    process: [
      "Initial examination and assessment",
      "Ultrasonic scaling to remove tartar",
      "Manual cleaning of hard-to-reach areas",
      "Polishing to smooth tooth surfaces",
      "Fluoride treatment for added protection"
    ],
    faqs: [
      { q: "How long does teeth cleaning take?", a: "Professional teeth cleaning typically takes 30-45 minutes." },
      { q: "Is teeth cleaning painful?", a: "Most patients experience no pain. For sensitive teeth, we offer gentle techniques and numbing options." },
      { q: "How often should I get teeth cleaning?", a: "We recommend professional cleaning every 6 months for best results." }
    ]
  },
  "scaling-and-polishing-east-tambaram": {
    title: "Scaling and Polishing in Chrompet | Dental Cleaning",
    h1: "Scaling and Polishing in Selaiyur Chennai",
    h2: "Complete Dental Cleaning for Healthier Smile",
    floatingCards: [
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/87afwn4w_card%201.jpg" },
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/zdp8mvhh_card%202.png" }
    ],
    intro: "Scaling and polishing is a professional dental cleaning procedure that removes calculus and stains from teeth. At Dr. Thamarai's Dental Care in West Tambaram, we use advanced ultrasonic scalers for effective and comfortable treatment.",
    benefits: [
      "Removes hardened calculus below gum line",
      "Prevents periodontitis and gum recession",
      "Smooth, polished tooth surfaces",
      "Reduces bacterial growth",
      "Improves overall oral hygiene"
    ],
    process: [
      "Comprehensive oral examination",
      "Ultrasonic scaling to break down tartar",
      "Hand scaling for precision cleaning",
      "Polishing with professional paste",
      "Post-treatment care instructions"
    ],
    faqs: [
      { q: "What is the difference between scaling and cleaning?", a: "Scaling removes tartar buildup below the gum line, while cleaning addresses surface plaque and stains." },
      { q: "Does scaling damage teeth?", a: "No, professional scaling is safe and actually protects your teeth from gum disease." },
      { q: "How long do results last?", a: "With good oral hygiene, scaling results last 6-12 months." }
    ]
  },
  "tooth-filling-chennai": {
    title: "Tooth Filling in Chennai | Cavity Treatment Rajakilpakkam",
    h1: "Tooth Filling Treatment in Chennai – Irumbuliyur",
    h2: "Pain-Free Cavity Filling & Restoration",
    floatingCards: [
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/87afwn4w_card%201.jpg" },
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/zdp8mvhh_card%202.png" }
    ],
    intro: "Tooth fillings restore teeth damaged by cavities or minor fractures. At Dr. Thamarai's Dental Care in Pallavaram, Chennai, we offer high-quality composite and amalgam fillings that blend naturally with your teeth.",
    benefits: [
      "Stops cavity progression",
      "Restores tooth structure and function",
      "Pain-free treatment with local anesthesia",
      "Natural-looking composite materials",
      "Long-lasting and durable results"
    ],
    process: [
      "Cavity examination and X-ray assessment",
      "Local anesthesia for pain-free treatment",
      "Removal of decayed tooth material",
      "Filling placement and shaping",
      "Polishing and bite adjustment"
    ],
    faqs: [
      { q: "How long do tooth fillings last?", a: "Composite fillings typically last 5-10 years with proper care." },
      { q: "Are white fillings better than silver?", a: "White composite fillings are aesthetic and bond well to teeth, making them a popular choice." },
      { q: "Is tooth filling painful?", a: "No, we use local anesthesia to ensure a completely pain-free experience." }
    ]
  },
  "dental-xray-tambaram": {
    title: "Dental X-Ray in Tambaram | Digital Dental Imaging Chennai",
    h1: "Digital Dental X-Ray Services in Tambaram",
    h2: "Advanced Diagnostic Imaging for Accurate Treatment",
    floatingCards: [
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/87afwn4w_card%201.jpg" },
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/zdp8mvhh_card%202.png" }
    ],
    intro: "Digital dental X-rays provide detailed images of your teeth, bones, and surrounding tissues. At Dr. Thamarai's Dental Care in Tambaram, we use state-of-the-art digital radiography with 90% less radiation than traditional X-rays.",
    benefits: [
      "Early detection of hidden dental problems",
      "90% less radiation exposure",
      "Instant image viewing and diagnosis",
      "Better treatment planning accuracy",
      "Environmentally friendly (no chemicals)"
    ],
    process: [
      "Patient positioning and protection",
      "Digital sensor placement",
      "Quick X-ray capture (seconds)",
      "Immediate image review",
      "Detailed diagnosis and treatment discussion"
    ],
    faqs: [
      { q: "Are dental X-rays safe?", a: "Yes, digital X-rays emit minimal radiation and are completely safe with proper protection." },
      { q: "How often should I get dental X-rays?", a: "Typically once a year, or as recommended based on your oral health condition." },
      { q: "What can dental X-rays detect?", a: "X-rays reveal cavities, bone loss, infections, impacted teeth, and other hidden problems." }
    ]
  },
  "invisible-braces-chennai": {
    title: "Invisible Braces in Chennai | Clear Aligners Chennai",
    h1: "Invisible Braces Treatment in Chennai – East Tambaram",
    h2: "Straighten Your Teeth Discreetly | Free 3D Scan",
    floatingCards: [
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/87afwn4w_card%201.jpg" },
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/zdp8mvhh_card%202.png" }
    ],
    intro: "Invisible braces, also known as clear aligners, are a modern alternative to traditional braces. At Dr. Thamarai's Dental Care in Chitlapakkam, Chennai, we offer invisible braces that straighten teeth without metal wires or brackets.",
    benefits: [
      "Virtually invisible appearance",
      "Removable for eating and cleaning",
      "No dietary restrictions",
      "Comfortable with no metal irritation",
      "Predictable results with 3D planning"
    ],
    process: [
      "Free consultation and 3D digital scan",
      "Custom treatment plan creation",
      "Receive your custom aligners",
      "Wear aligners 20-22 hours daily",
      "Regular progress monitoring every 6-8 weeks"
    ],
    faqs: [
      { q: "How long does invisible braces treatment take?", a: "Treatment typically takes 6-18 months depending on complexity." },
      { q: "Are invisible braces painful?", a: "Most patients experience minimal discomfort compared to traditional braces." },
      { q: "Can I eat with invisible braces?", a: "No, you should remove aligners while eating and drinking (except water)." }
    ]
  },
  "clear-aligners-east-tambaram": {
    title: "Clear Aligners in Tambaram Sanatorium | Invisible Teeth Straightening",
    h1: "Clear Aligners Treatment in Chrompet Chennai",
    h2: "Transform Your Smile with Invisible Aligners",
    floatingCards: [
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/87afwn4w_card%201.jpg" },
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/zdp8mvhh_card%202.png" }
    ],
    intro: "Clear aligners are transparent plastic trays that gradually move teeth into desired positions. Dr. Thamarai's Dental Care in Selaiyur offers advanced clear aligner treatment with free 3D smile simulation.",
    benefits: [
      "Invisible orthodontic solution",
      "Easy to maintain oral hygiene",
      "No food restrictions",
      "Fewer dental visits required",
      "Less treatment time than traditional braces"
    ],
    process: [
      "Comprehensive smile assessment",
      "Digital impressions and 3D scanning",
      "Virtual treatment planning",
      "Custom aligner fabrication",
      "Regular monitoring and refinements"
    ],
    faqs: [
      { q: "What is the cost of clear aligners?", a: "Cost varies based on case complexity. We offer affordable payment plans." },
      { q: "Do clear aligners work for everyone?", a: "Clear aligners treat most mild to moderate orthodontic issues." },
      { q: "How often do I need to visit the dentist?", a: "Typically every 6-8 weeks for progress checks." }
    ]
  },
  "invisible-braces-cost-chennai": {
    title: "Invisible Braces Cost in Chennai | Affordable Clear Aligners",
    h1: "Invisible Braces Cost in Chennai – Affordable Treatment Plans",
    h2: "Quality Orthodontic Care at Competitive Prices",
    floatingCards: [
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/87afwn4w_card%201.jpg" },
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/zdp8mvhh_card%202.png" }
    ],
    intro: "Understanding the cost of invisible braces is important for planning your smile transformation. At Dr. Thamarai's Dental Care in West Tambaram, we offer transparent pricing and flexible payment options for invisible braces treatment in Chennai.",
    benefits: [
      "Competitive pricing for quality care",
      "Flexible EMI options available",
      "Free initial consultation and 3D scan",
      "No hidden charges or surprise fees",
      "Insurance claim assistance"
    ],
    process: [
      "Free consultation to assess your needs",
      "Detailed cost breakdown provided",
      "Choose suitable payment plan",
      "Start treatment with confidence",
      "Complete support throughout treatment"
    ],
    faqs: [
      { q: "What is the average cost of invisible braces in Chennai?", a: "Costs typically range based on case complexity. Contact us for a personalized quote." },
      { q: "Do you offer EMI options?", a: "Yes, we provide flexible payment plans to make treatment affordable." },
      { q: "Is invisible braces more expensive than traditional braces?", a: "Pricing is comparable, and many find the benefits worth the investment." }
    ]
  },
  "aligners-for-crooked-teeth-tambaram": {
    title: "Aligners for Crooked Teeth in Tambaram | Fix Misaligned Teeth",
    h1: "Aligners for Crooked Teeth in Tambaram Chennai",
    h2: "Straighten Crooked Teeth with Clear Aligners",
    floatingCards: [
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/87afwn4w_card%201.jpg" },
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/zdp8mvhh_card%202.png" }
    ],
    intro: "Crooked teeth can affect your confidence and oral health. At Dr. Thamarai's Dental Care in Rajakilpakkam, we use clear aligners to straighten crooked teeth effectively without traditional braces.",
    benefits: [
      "Corrects crowded and overlapping teeth",
      "Improves bite alignment",
      "Enhances facial aesthetics",
      "Boosts confidence and self-esteem",
      "Easier dental hygiene maintenance"
    ],
    process: [
      "Detailed orthodontic assessment",
      "Digital imaging and treatment planning",
      "Custom aligner series creation",
      "Progressive teeth straightening",
      "Final smile perfection and retention"
    ],
    faqs: [
      { q: "Can aligners fix severely crooked teeth?", a: "Aligners are effective for mild to moderate cases. Severe cases may need alternative treatment." },
      { q: "How long does treatment take?", a: "Most cases are completed in 8-16 months." },
      { q: "Will my teeth stay straight after treatment?", a: "Yes, with proper retainer use, results are permanent." }
    ]
  },
  "aligners-for-teeth-gaps-east-tambaram": {
    title: "Aligners for Teeth Gaps in Irumbuliyur | Close Gaps Fast",
    h1: "Aligners for Teeth Gaps in Pallavaram Chennai",
    h2: "Close Gaps Between Teeth with Clear Aligners",
    floatingCards: [
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/87afwn4w_card%201.jpg" },
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/zdp8mvhh_card%202.png" }
    ],
    intro: "Gaps between teeth (diastema) can be cosmetically concerning. Dr. Thamarai's Dental Care in Tambaram offers clear aligner treatment to close gaps and create a uniform, beautiful smile.",
    benefits: [
      "Closes gaps effectively without surgery",
      "Natural-looking results",
      "Prevents food trapping",
      "Improves speech clarity",
      "Enhances overall smile aesthetics"
    ],
    process: [
      "Gap analysis and treatment planning",
      "3D smile preview showing final results",
      "Custom aligners designed to close gaps",
      "Gradual gap closure over treatment period",
      "Retention phase to maintain results"
    ],
    faqs: [
      { q: "How long does it take to close teeth gaps?", a: "Small to moderate gaps typically close in 4-10 months." },
      { q: "Will gaps reopen after treatment?", a: "No, with proper retainer wear, gaps remain closed permanently." },
      { q: "Is this treatment painful?", a: "Most patients report mild pressure but no significant pain." }
    ]
  },
  "braces-treatment-chennai": {
    title: "Braces Treatment in Chennai | Orthodontic Care Chennai",
    h1: "Braces Treatment in Chennai – East Tambaram",
    h2: "Metal & Ceramic Braces for Perfect Smile Alignment",
    floatingCards: [
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/87afwn4w_card%201.jpg" },
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/zdp8mvhh_card%202.png" }
    ],
    intro: "Traditional braces remain one of the most effective ways to correct complex orthodontic issues. At Dr. Thamarai's Dental Care in Chitlapakkam, Chennai, we offer comprehensive braces treatment with metal and ceramic options.",
    benefits: [
      "Treats complex orthodontic cases",
      "Reliable and time-tested method",
      "Corrects bite problems effectively",
      "Affordable orthodontic solution",
      "Suitable for all age groups"
    ],
    process: [
      "Comprehensive orthodontic evaluation",
      "Treatment plan and timeline discussion",
      "Braces placement and fitting",
      "Regular adjustments every 4-6 weeks",
      "Braces removal and retainer fitting"
    ],
    faqs: [
      { q: "How long does braces treatment take?", a: "Treatment typically ranges from 12-24 months depending on complexity." },
      { q: "Do braces hurt?", a: "Initial discomfort is normal but manageable with pain relief." },
      { q: "What foods should I avoid with braces?", a: "Avoid hard, sticky, and chewy foods that can damage brackets." }
    ]
  },
  "metal-braces-tambaram": {
    title: "Metal Braces in Tambaram | Affordable Orthodontic Treatment",
    h1: "Metal Braces Treatment in Tambaram Chennai",
    h2: "Strong & Effective Traditional Braces",
    floatingCards: [
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/87afwn4w_card%201.jpg" },
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/zdp8mvhh_card%202.png" }
    ],
    intro: "Metal braces are the most common and cost-effective orthodontic treatment. Dr. Thamarai's Dental Care in Tambaram Sanatorium provides high-quality metal braces with modern brackets for faster treatment.",
    benefits: [
      "Most economical braces option",
      "Extremely durable and strong",
      "Works for all orthodontic problems",
      "Faster treatment with modern brackets",
      "Suitable for children and adults"
    ],
    process: [
      "Initial orthodontic consultation",
      "Dental impressions and X-rays",
      "Bracket and wire placement",
      "Monthly adjustments and monitoring",
      "Completion and retention phase"
    ],
    faqs: [
      { q: "Are metal braces noticeable?", a: "Yes, metal braces are visible but modern brackets are smaller and sleeker." },
      { q: "Can adults wear metal braces?", a: "Absolutely! Braces work effectively at any age." },
      { q: "How to care for metal braces?", a: "Maintain excellent oral hygiene and avoid certain foods." }
    ]
  },
  "ceramic-braces-east-tambaram": {
    title: "Ceramic Braces in Chrompet | Clear Braces Chennai",
    h1: "Ceramic Braces in Selaiyur Chennai",
    h2: "Aesthetic Braces for Discreet Treatment",
    floatingCards: [
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/87afwn4w_card%201.jpg" },
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/zdp8mvhh_card%202.png" }
    ],
    intro: "Ceramic braces offer the effectiveness of traditional braces with a more aesthetic appearance. At Dr. Thamarai's Dental Care in West Tambaram, we use tooth-colored ceramic brackets that blend naturally with your teeth.",
    benefits: [
      "Less noticeable than metal braces",
      "Same effectiveness as metal braces",
      "Stain-resistant materials",
      "Comfortable and smooth",
      "Confidence during treatment"
    ],
    process: [
      "Orthodontic assessment and planning",
      "Custom ceramic bracket selection",
      "Precise bracket placement",
      "Regular adjustments and care",
      "Successful treatment completion"
    ],
    faqs: [
      { q: "Are ceramic braces more expensive?", a: "Ceramic braces cost slightly more than metal but offer aesthetic benefits." },
      { q: "Do ceramic braces stain?", a: "Modern ceramic brackets are stain-resistant with proper care." },
      { q: "How long does treatment take?", a: "Treatment time is similar to metal braces, typically 12-24 months." }
    ]
  },
  "braces-cost-chennai": {
    title: "Braces Cost in Chennai | Affordable Orthodontic Prices",
    h1: "Braces Cost in Chennai – Transparent Pricing",
    h2: "Affordable Braces with Flexible Payment Plans",
    floatingCards: [
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/87afwn4w_card%201.jpg" },
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/zdp8mvhh_card%202.png" }
    ],
    intro: "Understanding braces cost helps you plan your orthodontic treatment. Dr. Thamarai's Dental Care in Rajakilpakkam, Chennai offers transparent pricing for all types of braces with flexible payment options.",
    benefits: [
      "Clear cost breakdown provided upfront",
      "Multiple braces options at different price points",
      "Interest-free EMI available",
      "Free consultation and treatment planning",
      "Insurance coordination assistance"
    ],
    process: [
      "Free initial consultation",
      "Personalized treatment quote",
      "Discussion of payment options",
      "Choose suitable braces type",
      "Begin treatment with peace of mind"
    ],
    faqs: [
      { q: "What is the average cost of braces in Chennai?", a: "Costs vary by type: metal braces are most affordable, ceramic and clear aligners cost more." },
      { q: "Do you accept insurance?", a: "Yes, we help with insurance claims and verification." },
      { q: "Can I pay in installments?", a: "Yes, we offer flexible EMI options to make treatment affordable." }
    ]
  },
  "orthodontic-treatment-tambaram": {
    title: "Orthodontic Treatment in Tambaram | Best Orthodontist Chennai",
    h1: "Comprehensive Orthodontic Treatment in Tambaram",
    h2: "Expert Orthodontic Care for All Ages",
    floatingCards: [
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/87afwn4w_card%201.jpg" },
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/zdp8mvhh_card%202.png" }
    ],
    intro: "Orthodontic treatment corrects misaligned teeth and jaw problems. Dr. Thamarai's Dental Care in Irumbuliyur offers comprehensive orthodontic solutions including braces, aligners, and interceptive orthodontics for children.",
    benefits: [
      "Improves teeth and jaw alignment",
      "Enhances facial profile",
      "Prevents future dental problems",
      "Boosts confidence and self-esteem",
      "Better oral health and function"
    ],
    process: [
      "Comprehensive orthodontic diagnosis",
      "Treatment options discussion",
      "Customized treatment plan creation",
      "Active orthodontic treatment phase",
      "Retention and long-term care"
    ],
    faqs: [
      { q: "What age is best for orthodontic treatment?", a: "Children around age 7 should have an evaluation, but treatment works at any age." },
      { q: "How long does orthodontic treatment take?", a: "Treatment duration ranges from 6 months to 2+ years depending on complexity." },
      { q: "Is orthodontic treatment painful?", a: "Discomfort is minimal and temporary during adjustments." }
    ]
  },
  "dental-implants-chennai": {
    title: "Dental Implants in Chennai | Best Implant Dentist Pallavaram",
    h1: "Dental Implants in Chennai – Permanent Tooth Replacement",
    h2: "Advanced Implant Technology for Natural-Looking Teeth",
    floatingCards: [
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/87afwn4w_card%201.jpg" },
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/zdp8mvhh_card%202.png" }
    ],
    intro: "Dental implants are the gold standard for replacing missing teeth. At Dr. Thamarai's Dental Care in Tambaram, Chennai, we use advanced implant technology to restore your smile with permanent, natural-looking teeth.",
    benefits: [
      "Permanent tooth replacement solution",
      "Looks and functions like natural teeth",
      "Prevents bone loss and facial sagging",
      "No damage to adjacent teeth",
      "Long-lasting with proper care"
    ],
    process: [
      "Comprehensive implant assessment and planning",
      "Surgical implant placement in jawbone",
      "Healing and osseointegration (3-6 months)",
      "Abutment and crown placement",
      "Final adjustments and care instructions"
    ],
    faqs: [
      { q: "How long do dental implants last?", a: "With proper care, implants can last a lifetime." },
      { q: "Is dental implant surgery painful?", a: "The procedure is performed under anesthesia, so there's minimal discomfort." },
      { q: "Am I a candidate for dental implants?", a: "Most healthy adults with sufficient bone density are good candidates." }
    ]
  },
  "single-tooth-implant-tambaram": {
    title: "Single Tooth Implant in Tambaram | Replace One Missing Tooth",
    h1: "Single Tooth Implant in Tambaram Chennai",
    h2: "Replace One Missing Tooth with Dental Implant",
    floatingCards: [
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/87afwn4w_card%201.jpg" },
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/zdp8mvhh_card%202.png" }
    ],
    intro: "A single tooth implant replaces one missing tooth without affecting neighboring teeth. Dr. Thamarai's Dental Care in Chennai specializes in single tooth implants that look and function exactly like your natural tooth.",
    benefits: [
      "Preserves natural teeth structure",
      "No grinding of adjacent teeth",
      "Prevents bone deterioration",
      "Restores complete function",
      "Aesthetic natural appearance"
    ],
    process: [
      "Missing tooth evaluation",
      "Implant post placement",
      "Osseointegration period",
      "Custom crown fabrication",
      "Final crown placement and adjustment"
    ],
    faqs: [
      { q: "How long does single tooth implant take?", a: "The complete process takes 3-6 months from implant to crown." },
      { q: "Can I eat normally with an implant?", a: "Yes, after healing, you can eat anything you want." },
      { q: "What's the success rate?", a: "Dental implants have a 95-98% success rate." }
    ]
  },
  "full-mouth-dental-implants-chennai": {
    title: "Full Mouth Dental Implants in Chennai | All-on-4 Implants",
    h1: "Full Mouth Dental Implants in Chennai – Complete Smile Restoration",
    h2: "All-on-4 & All-on-6 Implant Solutions",
    floatingCards: [
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/87afwn4w_card%201.jpg" },
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/zdp8mvhh_card%202.png" }
    ],
    intro: "Full mouth dental implants restore all teeth with just 4-6 implants per arch. Dr. Thamarai's Dental Care in East Tambaram, Chennai offers All-on-4 and All-on-6 implant solutions for complete smile transformation.",
    benefits: [
      "Replace all missing teeth",
      "Requires fewer implants",
      "Immediate function possible",
      "Prevents bone loss",
      "Dramatic quality of life improvement"
    ],
    process: [
      "Comprehensive full mouth evaluation",
      "CT scan and surgical planning",
      "Implant placement surgery",
      "Temporary teeth attachment (same day possible)",
      "Final prosthesis placement after healing"
    ],
    faqs: [
      { q: "What is All-on-4 implants?", a: "All-on-4 uses four strategically placed implants to support a full arch of teeth." },
      { q: "Can I get teeth in one day?", a: "Yes, immediate loading with temporary teeth is often possible." },
      { q: "How much does full mouth implants cost?", a: "Costs vary based on individual needs. We provide detailed quotes after consultation." }
    ]
  },
  "teeth-replacement-east-tambaram": {
    title: "Teeth Replacement in Chitlapakkam | Missing Teeth Solutions",
    h1: "Teeth Replacement Options in Tambaram Sanatorium Chennai",
    h2: "Implants, Bridges & Dentures for Missing Teeth",
    floatingCards: [
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/87afwn4w_card%201.jpg" },
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/zdp8mvhh_card%202.png" }
    ],
    intro: "Missing teeth can be replaced with various options including implants, bridges, and dentures. Dr. Thamarai's Dental Care in Chrompet helps you choose the best teeth replacement solution for your needs and budget.",
    benefits: [
      "Restore chewing function",
      "Improve speech clarity",
      "Prevent remaining teeth shifting",
      "Enhance facial appearance",
      "Boost confidence and quality of life"
    ],
    process: [
      "Comprehensive oral examination",
      "Discussion of replacement options",
      "Treatment planning and cost estimation",
      "Implementation of chosen solution",
      "Follow-up care and maintenance"
    ],
    faqs: [
      { q: "What's the best option for teeth replacement?", a: "Dental implants are considered the gold standard, but we customize based on your situation." },
      { q: "How long does teeth replacement take?", a: "Timeline varies: implants take 3-6 months, bridges 2-3 weeks, dentures 4-6 weeks." },
      { q: "Is teeth replacement expensive?", a: "We offer solutions at various price points to fit different budgets." }
    ]
  },
  "implant-dentist-tambaram": {
    title: "Implant Dentist in Tambaram | Expert Implant Surgeon Chennai",
    h1: "Expert Implant Dentist in Tambaram Chennai",
    h2: "Skilled Dental Implant Surgeon with Advanced Training",
    floatingCards: [
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/87afwn4w_card%201.jpg" },
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/zdp8mvhh_card%202.png" }
    ],
    intro: "Finding an experienced implant dentist is crucial for successful dental implant treatment. Dr. Thamarai's Dental Care in Selaiyur has expert implant surgeons with advanced training and years of experience in implant dentistry.",
    benefits: [
      "Highly experienced implant specialists",
      "Advanced surgical techniques",
      "State-of-the-art equipment",
      "Personalized treatment approach",
      "Comprehensive post-operative care"
    ],
    process: [
      "Expert consultation and assessment",
      "Detailed treatment planning",
      "Precision implant surgery",
      "Careful monitoring during healing",
      "Final restoration and long-term care"
    ],
    faqs: [
      { q: "What qualifications should an implant dentist have?", a: "Look for specialized training in implantology and extensive clinical experience." },
      { q: "How many implants has your dentist placed?", a: "Our team has successfully placed thousands of implants over the years." },
      { q: "Do you use advanced technology?", a: "Yes, we use 3D imaging, surgical guides, and latest implant systems." }
    ]
  },
  "root-canal-treatment-chennai": {
    title: "Root Canal Treatment in Chennai | RCT in West Tambaram",
    h1: "Root Canal Treatment in Chennai – Pain-Free RCT",
    h2: "Advanced Endodontic Treatment to Save Your Tooth",
    floatingCards: [
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/87afwn4w_card%201.jpg" },
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/zdp8mvhh_card%202.png" }
    ],
    intro: "Root canal treatment (RCT) saves infected or damaged teeth. At Dr. Thamarai's Dental Care in Rajakilpakkam, Chennai, we perform pain-free root canal procedures using advanced techniques and equipment.",
    benefits: [
      "Saves your natural tooth",
      "Eliminates severe tooth pain",
      "Prevents infection spread",
      "Restores full tooth function",
      "More economical than extraction and replacement"
    ],
    process: [
      "Diagnosis with X-rays",
      "Local anesthesia administration",
      "Removal of infected pulp",
      "Cleaning and shaping of root canals",
      "Filling and sealing, followed by crown placement"
    ],
    faqs: [
      { q: "Is root canal treatment painful?", a: "No, with modern anesthesia, RCT is virtually painless." },
      { q: "How long does RCT take?", a: "Most treatments are completed in 1-2 visits." },
      { q: "What happens after root canal treatment?", a: "A crown is usually placed to protect and strengthen the tooth." }
    ]
  },
  "rct-dentist-tambaram": {
    title: "RCT Dentist in Tambaram | Root Canal Specialist Chennai",
    h1: "Expert RCT Dentist in Tambaram Chennai",
    h2: "Skilled Endodontist for Complex Root Canal Cases",
    floatingCards: [
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/87afwn4w_card%201.jpg" },
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/zdp8mvhh_card%202.png" }
    ],
    intro: "Expert RCT dentists ensure successful root canal treatment. Dr. Thamarai's Dental Care in Irumbuliyur has experienced endodontists who specialize in complex root canal procedures with high success rates.",
    benefits: [
      "Specialized endodontic training",
      "Use of dental microscope for precision",
      "Advanced rotary instruments",
      "Higher success rates",
      "Minimally invasive techniques"
    ],
    process: [
      "Comprehensive endodontic evaluation",
      "Precise diagnosis with digital X-rays",
      "Microscopic root canal therapy",
      "Thorough cleaning and disinfection",
      "Complete sealing and restoration"
    ],
    faqs: [
      { q: "When do I need to see an RCT specialist?", a: "For complex cases, retreatments, or when general dentist refers you." },
      { q: "What is the success rate of RCT?", a: "Root canal treatment has a 90-95% success rate." },
      { q: "How long does a root canal last?", a: "With proper care and a crown, root canal treated teeth can last a lifetime." }
    ]
  },
  "gum-treatment-east-tambaram": {
    title: "Gum Treatment in Pallavaram | Periodontal Care Chennai",
    h1: "Gum Treatment in Tambaram Chennai",
    h2: "Advanced Periodontal Care for Healthy Gums",
    floatingCards: [
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/87afwn4w_card%201.jpg" },
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/zdp8mvhh_card%202.png" }
    ],
    intro: "Gum disease affects millions and can lead to tooth loss if untreated. Dr. Thamarai's Dental Care in Chennai offers comprehensive gum treatment including deep cleaning, laser therapy, and gum surgery.",
    benefits: [
      "Prevents tooth loss",
      "Eliminates bad breath",
      "Reduces gum inflammation",
      "Stops gum recession",
      "Improves overall oral health"
    ],
    process: [
      "Comprehensive periodontal examination",
      "Deep cleaning (scaling and root planing)",
      "Laser gum therapy if needed",
      "Maintenance care program",
      "Regular monitoring and follow-ups"
    ],
    faqs: [
      { q: "What are signs of gum disease?", a: "Bleeding gums, swelling, bad breath, and loose teeth are common signs." },
      { q: "Is gum treatment painful?", a: "Modern techniques with anesthesia make treatment comfortable." },
      { q: "Can gum disease be reversed?", a: "Early stage (gingivitis) is reversible with proper treatment and care." }
    ]
  },
  "gum-disease-treatment-chennai": {
    title: "Gum Disease Treatment in Chennai | Periodontitis Care",
    h1: "Gum Disease Treatment in Chennai – Save Your Teeth",
    h2: "Effective Treatment for Gingivitis & Periodontitis",
    floatingCards: [
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/87afwn4w_card%201.jpg" },
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/zdp8mvhh_card%202.png" }
    ],
    intro: "Gum disease (periodontitis) is a serious infection that damages gums and destroys jawbone. At Dr. Thamarai's Dental Care in East Tambaram, Chennai, we provide advanced gum disease treatment to save your teeth and restore oral health.",
    benefits: [
      "Stops disease progression",
      "Preserves natural teeth",
      "Reduces systemic health risks",
      "Improves gum attachment",
      "Eliminates infection and inflammation"
    ],
    process: [
      "Detailed periodontal assessment",
      "Non-surgical therapy (scaling & root planing)",
      "Antimicrobial treatment",
      "Surgical intervention if needed",
      "Long-term maintenance plan"
    ],
    faqs: [
      { q: "What causes gum disease?", a: "Poor oral hygiene, smoking, genetics, and certain health conditions increase risk." },
      { q: "How long does treatment take?", a: "Treatment duration varies from a few weeks to several months depending on severity." },
      { q: "Will my gums grow back?", a: "Gum tissue doesn't naturally regenerate, but treatment stops further loss." }
    ]
  },
  "bleeding-gums-treatment-tambaram": {
    title: "Bleeding Gums Treatment in Tambaram | Stop Gum Bleeding",
    h1: "Bleeding Gums Treatment in Tambaram Chennai",
    h2: "Expert Care for Bleeding & Swollen Gums",
    floatingCards: [
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/87afwn4w_card%201.jpg" },
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/zdp8mvhh_card%202.png" }
    ],
    intro: "Bleeding gums are often the first sign of gum disease and should not be ignored. Dr. Thamarai's Dental Care in Chitlapakkam provides effective treatment to stop gum bleeding and restore gum health.",
    benefits: [
      "Identifies underlying cause",
      "Stops bleeding quickly",
      "Prevents disease progression",
      "Improves gum health",
      "Reduces inflammation and discomfort"
    ],
    process: [
      "Comprehensive gum examination",
      "Identification of bleeding cause",
      "Professional cleaning and treatment",
      "Oral hygiene instruction",
      "Follow-up monitoring"
    ],
    faqs: [
      { q: "Why do my gums bleed when I brush?", a: "Bleeding gums usually indicate inflammation or gum disease requiring professional care." },
      { q: "Should I stop brushing if my gums bleed?", a: "No, continue gentle brushing but see a dentist for proper evaluation." },
      { q: "Can bleeding gums be cured?", a: "Yes, with proper treatment and good oral hygiene, bleeding gums can be resolved." }
    ]
  },
  "wisdom-tooth-removal-chennai": {
    title: "Wisdom Tooth Removal in Chennai | Painless Extraction",
    h1: "Wisdom Tooth Removal in Chennai – Safe & Painless",
    h2: "Expert Wisdom Teeth Extraction in Tambaram Sanatorium",
    floatingCards: [
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/87afwn4w_card%201.jpg" },
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/zdp8mvhh_card%202.png" }
    ],
    intro: "Impacted wisdom teeth can cause pain, infection, and damage to adjacent teeth. Dr. Thamarai's Dental Care in Chrompet, Chennai specializes in safe, painless wisdom tooth removal with advanced surgical techniques.",
    benefits: [
      "Prevents crowding and misalignment",
      "Eliminates pain and infection",
      "Protects adjacent teeth",
      "Minimally invasive technique",
      "Fast healing and recovery"
    ],
    process: [
      "X-ray evaluation and surgical planning",
      "Local anesthesia or sedation",
      "Surgical extraction of wisdom tooth",
      "Wound closure and care instructions",
      "Follow-up for healing assessment"
    ],
    faqs: [
      { q: "When should wisdom teeth be removed?", a: "Removal is recommended for impacted, infected, or problematic wisdom teeth." },
      { q: "Is wisdom tooth removal painful?", a: "The procedure is painless with anesthesia. Post-operative discomfort is manageable." },
      { q: "How long is recovery?", a: "Most patients recover within 3-7 days with proper care." }
    ]
  },
  "tooth-extraction-tambaram": {
    title: "Tooth Extraction in Tambaram | Painless Dental Extraction",
    h1: "Tooth Extraction in Tambaram Chennai",
    h2: "Gentle & Pain-Free Tooth Removal",
    floatingCards: [
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/87afwn4w_card%201.jpg" },
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/zdp8mvhh_card%202.png" }
    ],
    intro: "Sometimes tooth extraction is necessary when a tooth is too damaged to save. At Dr. Thamarai's Dental Care in Selaiyur, we perform gentle, pain-free tooth extractions with minimal discomfort.",
    benefits: [
      "Eliminates source of infection",
      "Relieves severe tooth pain",
      "Prevents spread of decay",
      "Makes way for orthodontic treatment",
      "Minimal post-operative discomfort"
    ],
    process: [
      "Clinical and X-ray examination",
      "Local anesthesia administration",
      "Gentle tooth removal",
      "Socket care and stitching if needed",
      "Post-extraction care instructions"
    ],
    faqs: [
      { q: "When is tooth extraction necessary?", a: "Extraction is needed for severe decay, infection, crowding, or trauma." },
      { q: "What are my replacement options?", a: "Dental implants, bridges, or dentures can replace extracted teeth." },
      { q: "How long does healing take?", a: "The socket heals in 1-2 weeks, but complete healing takes 3-6 months." }
    ]
  },
  "emergency-dentist-east-tambaram": {
    title: "Emergency Dentist in West Tambaram | 24/7 Dental Care Chennai",
    h1: "Emergency Dentist in Rajakilpakkam Chennai",
    h2: "24/7 Emergency Dental Care When You Need It",
    floatingCards: [
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/87afwn4w_card%201.jpg" },
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/zdp8mvhh_card%202.png" }
    ],
    intro: "Dental emergencies require immediate attention. Dr. Thamarai's Dental Care in Irumbuliyur provides 24/7 emergency dental services for severe tooth pain, trauma, infections, and other urgent dental issues.",
    benefits: [
      "Immediate pain relief",
      "Prevents complications",
      "Same-day appointments",
      "Experienced emergency dentists",
      "Comprehensive emergency care"
    ],
    process: [
      "Call our emergency hotline",
      "Immediate assessment and triage",
      "Pain management and stabilization",
      "Emergency treatment or surgery",
      "Follow-up care planning"
    ],
    faqs: [
      { q: "What qualifies as a dental emergency?", a: "Severe pain, trauma, knocked-out tooth, abscess, or uncontrolled bleeding." },
      { q: "Do you accept walk-ins for emergencies?", a: "Yes, we accommodate emergency walk-ins and prioritize urgent cases." },
      { q: "What should I do if a tooth gets knocked out?", a: "Keep the tooth moist, place in milk if possible, and get to the dentist within 30 minutes." }
    ]
  },
  "dental-pain-treatment-chennai": {
    title: "Dental Pain Treatment in Chennai | Toothache Relief Tambaram",
    h1: "Dental Pain Treatment in Chennai – Fast Relief",
    h2: "Expert Care for Severe Tooth Pain & Toothache",
    floatingCards: [
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/87afwn4w_card%201.jpg" },
      { title: "", subtitle: "", image: "https://customer-assets.emergentagent.com/job_gentle-dental-4/artifacts/zdp8mvhh_card%202.png" }
    ],
    intro: "Severe dental pain can be debilitating and requires prompt treatment. At Dr. Thamarai's Dental Care in Pallavaram, Chennai, we provide fast, effective dental pain treatment to identify the cause and provide lasting relief.",
    benefits: [
      "Rapid pain relief",
      "Accurate diagnosis",
      "Treats underlying cause",
      "Prevents future problems",
      "Compassionate care"
    ],
    process: [
      "Emergency consultation",
      "Diagnostic examination and X-rays",
      "Immediate pain management",
      "Definitive treatment planning",
      "Follow-up care and monitoring"
    ],
    faqs: [
      { q: "What causes severe tooth pain?", a: "Common causes include decay, infection, abscess, cracked tooth, or gum disease." },
      { q: "How quickly can you see me for tooth pain?", a: "We offer same-day emergency appointments for dental pain." },
      { q: "Will the pain go away on its own?", a: "Dental pain rarely resolves without treatment and usually indicates a problem requiring professional care." }
    ]
  }
};
